import React from 'react';

const FruitTeaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="fruitt-bg" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#fbcfe8" />
        <stop offset="100%" stopColor="#fef3c7" />
      </radialGradient>
      <linearGradient id="fruitt-glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f472b6" />
        <stop offset="100%" stopColor="#f59e42" />
      </linearGradient>
    </defs>
    <ellipse cx="32" cy="54" rx="18" ry="6" fill="#f472b6" opacity="0.18" />
    <circle cx="32" cy="24" r="20" fill="url(#fruitt-bg)" opacity="0.18" />
    <rect
      x="20"
      y="10"
      width="24"
      height="36"
      rx="12"
      fill="url(#fruitt-glass)"
      stroke="#fff"
      strokeWidth="2"
    />
    <rect x="24" y="14" width="16" height="28" rx="8" fill="#fbcfe8" opacity="0.7" />
    <ellipse cx="32" cy="10" rx="12" ry="4" fill="#fbcfe8" />
  </svg>
);

export default FruitTeaIcon;
